<template>

<section class="hero hero--404 is-fullheight-with-navbar is-primary is-bold">
  <div class="hero-body">
    <div class="container">
      <h1 class="title is-size-1">
        {{$t('pagenotfound.code')}} 
      </h1>
      <h2 class="subtitle is-size-4">
       {{$t('pagenotfound.msg')}}
      </h2>
      <button @click="goToHome" class="button is-primary is-inverted is-outlined is-medium">{{$t('pagenotfound.back')}}</button>
    </div>
  </div>
</section>        

</template>

<script>
export default {
  name: 'pagenotfound',
  methods:{
    goToHome() {
      this.$router.push({ name: "search" });
    },      
  }
}
</script>

<style lang="scss" scoped>
// .main-content{
//     padding: 0;
// }

.hero--404{
    margin-top: -3.25em;
    margin-bottom: -3.25em;
}

</style>
